<template>
    <div>
        <DataTable
            :data="purchaseOrders"
            class="tw-mb-0"
            centered
            :columns="[
                {
                    title: 'Status',
                    field: 'status',
                },
                {
                    title: 'Title',
                    field: 'title',
                },
                {
                    title: 'Net Value',
                    field: 'value',
                },
                {
                    title: 'Supplier',
                    field: 'supplier',
                },
                {
                    title: '',
                    field: 'actions',
                    width: 60,
                },
            ]"
        >
            <template #column(status)="{ row }">
                <Tag :status="row.status" />
            </template>
            <template #column(title)="{ row }">
                {{ row.title }}
            </template>
            <template #column(value)="{ row }">
                {{ formatCurrency(row.subtotal, 2, row.target_currency, row.conversion_rate) }}
            </template>
            <template #column(supplier)="{ row }">
                {{ row.supplier.name }}
            </template>
            <template #column(actions)="{ row }">
                <div class="tw-flex tw-justify-end">
                    <Tooltip v-if="Auth.can('view purchase orders')" position="left" label="View">
                        <Button id="view-po" @click="openPO(row.id)"><i class="mdi mdi-eye"></i></Button>
                    </Tooltip>
                </div>
            </template>
        </DataTable>
        <Button v-if="!disabled" class="tw-w-full tw-px-3" @click="createPO()">
            <i class="mdi mdi-plus !tw-inline"></i>
            Create a Purchase Order
        </Button>
    </div>
</template>
<script>
import DataTable from '@/js/components/tables/DataTable.vue';
import { formatCurrency } from '@/js/utils.js';
import Button from '@/js/components/controls/Button.vue';
import Tooltip from '@/js/components/Tooltip.vue';
import Tag from '@/js/components/Tag.vue';

export default {
    components: {
        DataTable,
        Button,
        Tooltip,
        Tag,
    },
    props: {
        entry: {
            type: Object,
        },
        purchaseOrders: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['opened'],
    data() {
        return {
            formatCurrency,
        };
    },
    methods: {
        openPO(id) {
            Eventbus.$emit('purchaseOrder:view', {
                purchaseOrder: id,
                source: {
                    emitter: 'budget:entry',
                    payload: {
                        event: this.entry.event_id,
                        entry: this.entry.id,
                    },
                },
            });
            this.$emit('opened');
        },
        createPO() {
            if (!Auth.can('create purchase orders')) {
                return;
            }
            Eventbus.$emit('purchase-order:create', {
                department: this.entry.category.department_id,
                category: this.entry.category.id,
                title: this.entry.name,
                supplier: this.entry.supplier_id,
                entry: this.entry.id,
            });
        },
    },
};
</script>
